import { inject } from 'mobx-react';
import propTypes from 'prop-types';

const _Distributor = (props) => {
  const {
    labelsStore,
    optionsStore: { getPricingCtaURL },
    cartStore, isCartTransferAvailable
  } = props;

  const getPricing = getPricingCtaURL
    && (
      <a
        href={getPricingCtaURL}
        role="button"
        title={labelsStore.giftlistGetPricing}
        className="btn btn-wide btn-primary actions-block__btn"
        data-autotests-id="cart-btn-get-pricing"
      >
        {labelsStore.giftlistGetPricing}
      </a>
    );

  const buyOnline = isCartTransferAvailable && (
    <button
      title={labelsStore.ctLabelsBuyOnlineBtnLabel}
      type="button"
      className="btn btn-wide btn-primary actions-block__btn actions-block__btn--cart-transfer"
      onClick={cartStore.openCartTransferModal}
    >
      {labelsStore.ctLabelsBuyOnlineBtnLabel}
    </button>
  );

  const whereToBuyOrContactSales = getB2BHelpButton(props);
  const buyInStoreOrFindElectrician = getB2CHelpButton(props);

  const helpButton = whereToBuyOrContactSales || buyInStoreOrFindElectrician;

  const result = isCartTransferAvailable ? (
    <>
      {buyOnline}
      {helpButton}
    </>
  ) : (getPricing || helpButton);

  return (result || null);
};

function getB2BHelpButton({ labelsStore, optionsStore, isCartTransferAvailable }) {
  const {
    whereToBuyURL,
    contactSalesURL
  } = optionsStore;

  let whereToBuyOrContactSalesURL;
  let whereToBuyOrContactSalesLabel;

  if (whereToBuyURL) {
    whereToBuyOrContactSalesURL = whereToBuyURL;
    whereToBuyOrContactSalesLabel = isCartTransferAvailable
      ? labelsStore.ctLabelsBuyNearBtnLabel
      : labelsStore.whereToBuy;
  } else if (contactSalesURL) {
    whereToBuyOrContactSalesURL = contactSalesURL;
    whereToBuyOrContactSalesLabel = labelsStore.contactSalesLabel;
  }

  return whereToBuyOrContactSalesURL
    && (
      <a
        href={whereToBuyOrContactSalesURL}
        role="button"
        title={whereToBuyOrContactSalesLabel}
        className={`btn btn-wide actions-block__btn${isCartTransferAvailable ? '' : ' btn-primary'}`}
      >
        {whereToBuyOrContactSalesLabel}
      </a>
    );
}

function getB2CHelpButton({ labelsStore, optionsStore, isCartTransferAvailable }) {
  const {
    b2cBuyInStoreURL,
    b2cFindElectricianURL
  } = optionsStore;

  let buyInStoreOrFindElectricianURL;
  let buyInStoreOrFindElectricianLabel;

  if (b2cBuyInStoreURL) {
    buyInStoreOrFindElectricianURL = b2cBuyInStoreURL;
    buyInStoreOrFindElectricianLabel = labelsStore.buyInStoreLabel;
  } else if (b2cFindElectricianURL) {
    buyInStoreOrFindElectricianURL = b2cFindElectricianURL;
    buyInStoreOrFindElectricianLabel = labelsStore.findElectricianLabel;
  }

  return buyInStoreOrFindElectricianURL
    && (
      <a
        href={buyInStoreOrFindElectricianURL}
        role="button"
        title={buyInStoreOrFindElectricianLabel}
        className={`btn btn-wide actions-block__btn${isCartTransferAvailable ? '' : ' btn-primary'}`}
      >
        {buyInStoreOrFindElectricianLabel}
      </a>
    );
}

_Distributor.propTypes = {
  labelsStore: propTypes.shape({
    whereToBuy: propTypes.string,
    contactSalesLabel: propTypes.string,
    giftlistGetPricing: propTypes.string
  }),

  optionsStore: propTypes.shape({
    whereToBuyURL: propTypes.string,
    contactSalesURL: propTypes.string,
    getPricingCtaURL: propTypes.string,
    b2cBuyInStoreURL: propTypes.string,
    b2cFindElectricianURL: propTypes.string
  }),

  cartStore: propTypes.shape({
    openCartTransferModal: propTypes.func,
    totalQuantity: propTypes.number
  }),

  isCartTransferAvailable: propTypes.bool.isRequired
};

export const Distributor = inject((allStores) => ({
  labelsStore: allStores.labelsStore,
  optionsStore: allStores.optionsStore,
  cartStore: allStores.cartStore,
  isCartTransferAvailable: allStores.cartStore.isCartTransferAvailable
}))(_Distributor);
